/**
 * Re-exported from @hyperframes/engine.
 * @see engine/src/services/videoFrameInjector.ts for implementation.
 */
export { createVideoFrameInjector } from "@hyperframes/engine";
